import React from 'react';
import ReactDOM from 'react-dom';

// Main Page
import MinimumPensionEstimatorApp from './MinimumPensionEstimatorApp';

// Polyfill
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import './polyfills';

// SW
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  <React.StrictMode>
    <MinimumPensionEstimatorApp />
  </React.StrictMode>,
  document.getElementById('root')
);

serviceWorker.unregister();